import config from '@/config'

export default {
	id: 'SIMPLE_PREMIUM_1M_38_95_1M_14_99_EN_CLUSTER',
	providers: {
		stripe: config('stripe_cheap_and_short'),
		braintree: 'pro_short_cheap',
		paltaMap: {
			USD: 'simple_premium_1m_38_95_1m_14_99_usd',
			GBP: 'simple_premium_1m_38_95_1m_15_19_gbp',
			CAD: 'simple_premium_1m_49_99_1m_18_99_cad',
			AUD: 'simple_premium_1m_49_99_1m_22_99_aud',
		},
		primer: 'prd_eSzoceF2Bmuo',
	},
	model: {
		commitment_period: 0,
		intro_period_value: 1,
		intro_period_type: 'month',
		next_period_value: 1,
		next_period_type: 'month',
	},
	trial: {
		days: 30,
		priceMap: {
			USD: 14.99,
			GBP: 15.19,
			CAD: 18.99,
			AUD: 22.99,
		},
		originalPriceMap: {
			USD: 38.95,
			GBP: 38.95,
			CAD: 49.99,
			AUD: 49.99,
		},
	},
	subscription: {
		interval: 'month',
		intervalCount: 1,
		priceMap: {
			USD: 38.95,
			GBP: 38.95,
			CAD: 49.99,
			AUD: 49.99,
		},
	},
	options: ($t) => ({
		explicitTermsPeriodText: $t('pages.program.organic.cheap_and_short.plans.30_days.into_period_text'), // 'first month'
		explicitTermsIntervalText: $t('pages.program.organic.cheap_and_short.plans.30_days.sub_period_text'), // 'monthly'
		billingSubtitlePeriodText: $t('pages.program.cheap_and_short.plans.30_days.into_period_text'), // 'first month'
		footerPeriodText: $t('pages.program.cheap_and_short.plans.30_days.period_text'), // '1-month'
		footerIntervalText: $t('pages.program.cheap_and_short.plans.30_days.sub_period_text'), // 'monthly'
	}),
}
